/**
 * @param {String} equipStatus 
 * @returns {String} 获取车辆引擎状态
 */
export const getACCStatus = (equipStatus) => {
	if (equipStatus !== null && equipStatus !== '') {
		var formatStatus = equipStatus.split('');

		return (formatStatus[0] === '0' ? '停止' : '启动');
	} else {
		return '-';
	}
};

export const isSupportCanvas = () => {//判断浏览区是否支持canvas
    var elem = document.createElement('canvas');
    return !!(elem.getContext && elem.getContext('2d'));
};

export const getUrlParam = (name) => {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); //正则表达式过滤
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return decodeURI(r[2]);
    }
    return null;
};

export const formatContent = (content) => {
    if (content !== undefined && content !== null) {
        content = content.replace(/\n|\r\n/g, '<br/>');
    }
    return content;
};

export const formatMileage = (mileage) => {
    var m = mileage % 1000, l = Math.floor(mileage / 1000);

    if (l == 0) {
        return m + "米";
    }
    return l + "公里" + (m > 0 ? (m + "米") : "");
};

export const getLocationStatus = (status) => {
    if (status[1] == '0') {
        return '基站定位'
    } else {
        return '卫星定位'
    }
};

export const mtimeDeltaCount = (time) => {
    var that = this, s = time % 60;
    var m = Math.floor(time / 60) % 60;
    var h = Math.floor(Math.floor(time / 60) / 60) % 24;
    var d = Math.floor(Math.floor(Math.floor(time / 60) / 60) / 24);
    if (d !== 0) {
        return d + "天" + h + "小时" + m + "分";
    }
    if (h !== 0) {
        return h + "小时" + m + "分";
    }
    return m + "分";
};

export const timeDeltaCount = (time) => {
    var that = this, s = time % 60;
    var m = Math.floor(time / 60) % 60;
    var h = Math.floor(Math.floor(time / 60) / 60) % 24;
    var d = Math.floor(Math.floor(Math.floor(time / 60) / 60) / 24);
    if (d !== 0) {
        return d + "天" + h + "小时" + m + "分" + s + "秒";
    }
    if (h !== 0) {
        return h + "小时" + m + "分" + s + "秒";
    }
    if (m !== 0) {
        return m + "分" + s + "秒";
    }
    return s + "秒";
};

export const getCarStatus = (warnName, stateName, drive, iconType) => {
    var that = this;
    var carStatus = '';


    if (warnName && stateName) {
        if (warnName !== '[]' && stateName !== '[]') {
            carStatus = warnName.substr(1, warnName.length - 1) + ',' + stateName.substr(1, stateName.length - 1) + ',';
        } else if (warnName === '[]' && stateName !== '[]') {
            carStatus = stateName.substr(1, stateName.length - 1) + ',';
        } else if (warnName !== '[]' && stateName === '[]') {
            carStatus = warnName.substr(1, warnName.length - 1) + ',';
        }
    }
    if (parseInt(drive) < 0) {
        carStatus = (iconType <= 3 ? '停车' : '静止') + timeDeltaCount(Math.abs(drive));
    }

    return (carStatus.length == 0 ? '-' : carStatus);
};

/**
 * @param {String} iconType 
 * @param {String} showType 
 * @param {String} onlineStatus 
 * @param {String} alarmContent 
 * @param {String} speed 
 * @returns {String} 获取车标
 */
export const getShowIcon = (iconType, showType, onlineStatus, alarmContent, speed) => {
	var color = '';

	if (onlineStatus == '在线') {
		if (alarmContent.length > 0) {
			color = 'red'
		} else if (showType == 'list' || (alarmContent.length == 0 && (showType == 'markerIcon' && speed > 0))) {
			color = 'blue'
		} else if (alarmContent.length == 0 && (showType == 'markerIcon' && speed == 0)) {
			color = 'green'
		}
	} else {
		color = 'gray'
	}

	if (iconType == 1) {
		if (showType == 'list') {
			return 'images/vehicle/icon-car-' + color + '.png';
		} else if (showType == 'markerIcon') {
			return 'images/vehicle/marker-car-' + color + '.png';
		}
	} else if (iconType == 2) {
		if (showType == 'list') {
			return 'images/vehicle/icon-truck-' + color + '.png';
		} else if (showType == 'markerIcon') {
			return 'images/vehicle/marker-truck-' + color + '.png';
		}
	} else if (iconType == 3) {
		if (showType == 'list') {
			return 'images/vehicle/icon-moto-' + color + '.png';
		} else if (showType == 'markerIcon') {
			return 'images/vehicle/marker-moto-' + color + '.png';
		}
	} else if (iconType == 4) {
		if (showType == 'list') {
			return 'images/vehicle/icon-people-' + color + '.png';
		} else if (showType == 'markerIcon') {
			return 'images/vehicle/marker-people-' + color + '.png';
		}
	} else if (iconType == 5) {
		if (showType == 'list') {
			return 'images/vehicle/icon-pet-' + color + '.png';
		} else if (showType == 'markerIcon') {
			return 'images/vehicle/marker-pet-' + color + '.png';
		}
	}
};